export default __webpack_public_path__ + "static/media/aldemat_navicon-light.3f1b15aa.svg";